import script from "./SampleCollectionLaboratory.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleCollectionLaboratory.vue?vue&type=script&setup=true&lang=js"

import "./SampleCollectionLaboratory.vue?vue&type=style&index=0&id=5689dca7&lang=css"

const __exports__ = script;

export default __exports__